var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "TrainHeaderView" },
    [
      _c("div", { staticClass: "TrainHeaderView_box" }, [
        _c("div", { staticClass: "TrainHeaderView_wrap" }, [
          _c("div", { staticClass: "header_left", on: { click: _vm.toHome } }, [
            _c("img", {
              staticClass: "img_item logo",
              attrs: { src: _vm.$imgUrl + _vm.pageConfig.logo, alt: "" }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.pageConfig.schoolName) + "继续教育综合平台")
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "header_middle" },
            _vm._l(_vm.routerConfig, function(item, key, index) {
              return _c(
                "router-link",
                {
                  key: item + key + index,
                  staticClass: "router_item",
                  attrs: { to: item.url }
                },
                [_vm._v(_vm._s(item.text))]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "header_right_box" }, [
            _c(
              "div",
              {
                staticClass: "right_item right_1",
                class: { right_active: _vm.$route.name === "myMsg" },
                on: {
                  click: function($event) {
                    return _vm.$router.push({ name: "myMsg" })
                  }
                }
              },
              [
                _c("img", {
                  attrs: {
                    src: require("../../../assets/images/my_msg.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("收件箱")]),
                _vm._v(" "),
                _vm.msgNum
                  ? _c("span", { staticClass: "drow_num" }, [
                      _vm._v(_vm._s(_vm.msgNum))
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "right_item right_2",
                class: {
                  right_notice_active: _vm.$route.query.key === "system"
                },
                on: {
                  click: function($event) {
                    return _vm.toNoticePage("system")
                  }
                }
              },
              [
                _c("img", {
                  attrs: {
                    src: require("../../../assets/images/msg.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("消息通知")])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "header_logined right_3",
                on: {
                  mouseenter: function($event) {
                    return _vm.showDropBox("up")
                  },
                  mouseleave: function($event) {
                    return _vm.showDropBox("down")
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "login_ava",
                  attrs: {
                    src: require("../../../assets/images/avatar_ico.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "user_name",
                  domProps: { textContent: _vm._s(_vm.userName) }
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "el-icon-arrow-down select_arrow",
                  class: {
                    select_arrow_1: _vm.showDrop === "up",
                    select_arrow_2: _vm.showDrop === "down"
                  }
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "select_drow" },
                  [
                    _vm._l(_vm.dropConfig, function(item, key, index) {
                      return _c(
                        "li",
                        {
                          key: item + key + index,
                          staticClass: "drow_item",
                          class: { active_drop: _vm.currentPathName === key },
                          on: {
                            click: function($event) {
                              return _vm.handlerPage(key)
                            }
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "drow_text",
                            domProps: { textContent: _vm._s(item.text) }
                          })
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "login_out_btn",
                        on: { click: _vm.toLoginOut }
                      },
                      [_vm._v("退出")]
                    )
                  ],
                  2
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "switch_box" }, [
            _vm.pagePath !== "loginout" && _vm.authList.length >= 2
              ? _c("div", { staticClass: "tab_switch" }, [
                  _vm.authList.includes("adultTeach") ||
                  _vm.authList.includes("studyOnline")
                    ? _c(
                        "div",
                        {
                          staticClass: "switch_item",
                          class: { active: _vm.currentAuth === "teach" },
                          on: {
                            click: function($event) {
                              return _vm.switchAuth("teach")
                            }
                          }
                        },
                        [_vm._v("\n          成教\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.authList.includes("train")
                    ? _c(
                        "div",
                        {
                          staticClass: "switch_item",
                          class: { active: _vm.currentAuth === "train" },
                          on: {
                            click: function($event) {
                              return _vm.switchAuth("train")
                            }
                          }
                        },
                        [_vm._v("\n          培训\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.authList.includes("selfExam")
                    ? _c(
                        "div",
                        {
                          staticClass: "switch_item",
                          class: { active: _vm.currentAuth === "selfExam" },
                          on: {
                            click: function($event) {
                              return _vm.switchAuth("selfExam")
                            }
                          }
                        },
                        [_vm._v("\n          自考\n        ")]
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.showSearch
        ? _c(
            "div",
            { staticClass: "TrainHeaderView_search" },
            [_c("SearchView")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showQrCodeDialog,
            width: "420px",
            center: "",
            "close-on-click-modal": false,
            "custom-class": "wechat-qrcode-dialog"
          },
          on: {
            "update:visible": function($event) {
              _vm.showQrCodeDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "qrcode-dialog-content" }, [
            _c("div", { staticClass: "wechat-header" }, [
              _c("i", { staticClass: "el-icon-chat-dot-round wechat-icon" }),
              _vm._v(" "),
              _c("span", { staticClass: "wechat-title" }, [
                _vm._v("微信扫码绑定")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "qrcode-tip" }, [
              _vm._v("请使用微信扫一扫")
            ]),
            _vm._v(" "),
            _c("div", {
              ref: "qrcode",
              staticClass: "qrcode-container",
              attrs: { id: "qrcode" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "qrcode-footer" }, [
              _vm._v("扫描上方二维码完成绑定")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn-group" }, [
              _c(
                "div",
                {
                  staticClass: "refresh-btn",
                  on: { click: _vm.refreshQrCode }
                },
                [
                  _c("i", { staticClass: "el-icon-refresh" }),
                  _vm._v("\n          刷新二维码\n        ")
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "close-btn",
                  on: {
                    click: function($event) {
                      _vm.showQrCodeDialog = false
                    }
                  }
                },
                [_vm._v("关闭")]
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb05ef82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb05ef82","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/train/TrainHeaderView.vue
// module id = null
// module chunks = 